module.exports = __webpack_public_path__ + "static/media/cbs-tv-bbt-top.517ec2f5.png";